import { DiscoveryRequestTask } from "../models/DiscoveryRequestTask";
import { clean } from "../utils/utils";
import api from "./api"; // the custom Axios instance

const PATH = "/api/v1/discovery-request-tasks"; // Adjust the path as per your API

export const DiscoveryRequestTaskService = {
  async createDiscoveryRequestTask(
    discoveryRequestData: Omit<
      DiscoveryRequestTask,
      "_id" | "createdAt" | "updatedAt" | "createdById" | "updatedById"
    >,
  ): Promise<string> {
    const response = await api.post(PATH, clean(discoveryRequestData));
    return response.data.data._id;
  },

  async getDiscoveryRequestTask(
    discoveryRequestId: string,
  ): Promise<DiscoveryRequestTask> {
    const response = await api.get(`${PATH}/${discoveryRequestId}`);
    return response.data.data; // Return null if no data found
  },

  async updateDiscoveryRequestTask(
    discoveryRequestId: string,
    updatedData: Partial<Omit<DiscoveryRequestTask, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.put(`${PATH}/${discoveryRequestId}`, clean(updatedData));
  },

  async deleteDiscoveryRequestTask(discoveryRequestId: string): Promise<void> {
    await api.delete(`${PATH}/${discoveryRequestId}`);
  },

  async getDiscoveryRequestFiles(discoveryRequestId: string): Promise<any[]> {
    const res = await api.get(`${PATH}/${discoveryRequestId}/files`);
    return res.data.data ?? [];
  },
};
